module.exports = __webpack_public_path__ + "static/media/Group.c12c5c01.svg";